import { AxiosResponse } from 'axios'
import { DeepPartial } from 'react-hook-form'

import { requestUrls } from 'src/configs/url'

import service from './service'

import { FilterParams, ResponseResult } from 'src/types/common/types'
import { Folder, MentorCloudFile } from 'src/types/files/file'

export type GetFolderRequest = FilterParams<keyof Folder, number | boolean>
export type GetFolderResponse = ResponseResult<Folder[]>
export type GetFileRequest = FilterParams<keyof MentorCloudFile, number | boolean | string | string[]>
export type GetFileResponse = ResponseResult<MentorCloudFile[]>
export type CreateFolderRequest = FilterParams<keyof Folder, unknown, Omit<Folder, 'files' | 'id' | 'created_at_epoch'>>
export type CreateFolderResponse = ResponseResult<number>
export type RenameFolderRequest = FilterParams<keyof Folder, unknown, Pick<Folder, 'id' | 'name'>>
export type RenameFolderResponse = ResponseResult<number>
export type DeleteFolderRequest = FilterParams<keyof Folder>
export type DeleteFolderResponse = ResponseResult<boolean>
export type AddFileRequest = FilterParams<keyof MentorCloudFile, unknown, Omit<MentorCloudFile, 'id' | 'portal_id'>>
export type AddFileResponse = ResponseResult<number>
export type UpdateFileRequest = FilterParams<keyof MentorCloudFile, unknown, DeepPartial<MentorCloudFile> & Pick<MentorCloudFile, 'id'>>
export type UpdateFileResponse = ResponseResult<number>
export type RenameFileRequest = FilterParams<keyof MentorCloudFile, unknown, Pick<MentorCloudFile, 'id' | 'name'>>
export type RenameFileResponse = ResponseResult<number>
export type DeleteFileRequest = { media_file_id: number }
export type DeleteFileResponse = ResponseResult<boolean>

const mentorCloudService = {
  getFolder: async (requestBody?: GetFolderRequest): Promise<AxiosResponse<GetFolderResponse>> => {
    return service.post(requestUrls.getFolder, requestBody)
  },
  getFile: async (requestBody?: GetFileRequest): Promise<AxiosResponse<GetFileResponse>> => {
    return service.post(requestUrls.getFiles, requestBody)
  },
  createFolder: async (requestBody: CreateFolderRequest): Promise<AxiosResponse<CreateFolderResponse>> => {
    return service.post(requestUrls.createFolder, requestBody)
  },
  renameFolder: async (requestBody: RenameFolderRequest): Promise<AxiosResponse<RenameFolderResponse>> => {
    return service.post(requestUrls.renameFolder, requestBody)
  },
  deleteFolder: async (requestBody: DeleteFolderRequest): Promise<AxiosResponse<DeleteFolderResponse>> => {
    return service.post(requestUrls.deleteFolder, requestBody)
  },
  duplicateFile: async (requestBody: AddFileRequest): Promise<AxiosResponse<AddFileResponse>> => {
    return service.post(requestUrls.addFile, requestBody)
  },
  updateFile: async (requestBody: UpdateFileRequest): Promise<AxiosResponse<UpdateFileResponse>> => {
    return service.post(requestUrls.updateFile, requestBody)
  },
  renameFile: async (requestBody: RenameFileRequest): Promise<AxiosResponse<RenameFileResponse>> => {
    return service.post(requestUrls.renameFile, requestBody)
  },
  deleteFile: async (requestBody: DeleteFileRequest): Promise<AxiosResponse<DeleteFileResponse>> => {
    return service.post(requestUrls.deleteFile, requestBody)
  },
}

export default mentorCloudService
